import { OptionInterface } from '../models';
import { AmPmEnum, MonthDaysEnum, WeekDaysEnum } from '../enums';

export const weekDaysOptions: OptionInterface[] = [
    {
        value: WeekDaysEnum.SUN,
        description: 'Sunday',
    },
    {
        value: WeekDaysEnum.MON,
        description: 'Monday',
    },
    {
        value: WeekDaysEnum.TUE,
        description: 'Tuesday',
    },
    {
        value: WeekDaysEnum.WED,
        description: 'Wednesday',
    },
    {
        value: WeekDaysEnum.THU,
        description: 'Thursday',
    },
    {
        value: WeekDaysEnum.FRI,
        description: 'Friday',
    },
    {
        value: WeekDaysEnum.SAT,
        description: 'Saturday',
    }
];
export const monthDaysOptions: OptionInterface[] = [
    {
        value: MonthDaysEnum.FIRST,
        description: `${MonthDaysEnum.FIRST}`
    },
    {
        value: MonthDaysEnum.FIFTEENTH,
        description: `${MonthDaysEnum.FIFTEENTH}`
    },
    {
        value: MonthDaysEnum.LAST,
        description: 'Last'
    }
];
export const hoursOptions: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const ampmOptions: string[] = [AmPmEnum.AM, AmPmEnum.PM];
